// extracted by css-extract-rspack-plugin
export default {"poweredByLogo":"poweredByLogo-r4OrDM","poweredByDivider":"poweredByDivider-hKoUfu","root":"root-_9QLze"};